import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useSuburbanListingParameters } from './hooks/useSuburbanListingParameters';

interface IAdBannerMicrofrontendSuburbanListingContainerProps {
  manifest: IMicrofrontendManifest;
  position: number;
  onStub?: () => void;
  onError?: () => void;
  onClose?: () => void;
}

/**
 * Place-контейнер загородного листингового баннера: поставляет параметры места
 * и рендерит generic-контейнер.
 */
export const AdBannerMicrofrontendSuburbanListingContainer: React.FC<
  IAdBannerMicrofrontendSuburbanListingContainerProps
> = ({ manifest, position, onStub, onError, onClose }) => {
  const parameters = useSuburbanListingParameters({ position });

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={onStub}
      onError={onError}
      onClose={onClose}
    />
  );
};
